module.exports = __webpack_public_path__ + "static/media/chevron-large--active.5501f3e9.svg";